import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import SideBar from "./SideBar";
import Settings from "./Settings";
import Profile from "../profile/Profile";
import EditProfile from "../profile/EditProfile";
import ProfilePhotoEdit from "../profile/ProfilePhotoEdit";
import PeopleNear from "../findExplore/PeopleNearYou";
import Visitors from "../visitors/Visitors";
import Filter from "./Filter";
import Feeds from "./Feeds";
// import Boost from './Boost';
import Payment from "./Payment";
import Boostpayment from "./Boostpayment";
import Superlikepayment from "./Superlikepayment";
import Friends from "../friends/Friends";
import FriendRequests from "../friendRequests/FriendRequests";
import Banner from "../banner/BannerList";
import BannerAdd from "../banner/BannerAdd";
import BannnerView from "../banner/BannerView";
import BannerExpired from "../banner/BannerExpired";
import FindNewPeople from "../findExplore/FindNewPeople";
import Message from "../message/Message";
import MessageNew from "../message/MessageNew";
import VisitorNew from "../visitors/VisitorNew";
import FriendRequestNew from "../friendRequests/FriendRequestNew";
import FriendsNew from "../friends/FriendsNew";
import Help from "../help/Help";
import PeopleExplore from "../findExplore/PeopleExplore";
import Explore from "../findExplore/Explore";
//New Updates
import LikeRequests from "../friendRequests/LikeRequests";
import LikeRequestNew from "../friendRequests/LikeRequestNew";

import ls from "local-storage";
import { options } from "../../config/options";

import NotFound from "../NotFound/NotFound";
import Cookies from "universal-cookie";
import axios from "axios";
import Signin from "../welcome/Signin";
import Editphonefirebase from "../profile/Editphonefirebase";
// wallet
import WalletHistory from "./WalletHistory";
import Wallet from "./Wallet";
import WalletPayment from "./WalletPayment";
import PaymentSuccPage from "./PaymentSuccPage";
import CibSuccPage from "./CibSuccPage";
import PaymentOptions from "./PaymentOptions";
import ScratchCard from "./ScratchCard";
import QRcode from "./QRcode";

// promotinaloffer
import Promotinaloffer from "./Promotinaloffer";
import SpecialPackageCoupon from "./SpecialPackageCoupon";

import Cibpay from "./Cibpay";
import { CAPTURE_EVENT, IDENTIFY_USER } from "../../Services/PosthogService";

// Temporary: show the full-screen tutorial overlay after login too (not only first signup).
// Set to false before production so overlay runs only when show_signup_tutorial_video is set.
const SHOW_TUTORIAL_OVERLAY_AFTER_LOGIN_FOR_TESTING = false;

function readTutorialVideoUrlFromSettings() {
  try {
    const settings = JSON.parse(localStorage.getItem("settings") || "{}");
    const url =
      typeof settings.tutorial_video_url === "string"
        ? settings.tutorial_video_url.trim()
        : "";
    return url;
  } catch (e) {
    return "";
  }
}

// Sidebar "Tutorial" menu: plays admin-configured MP4 from settings.tutorial_video_url (admindatas).
const TutorialVideoPage = () => {
  const [videoUrl, setVideoUrl] = React.useState(() =>
    readTutorialVideoUrlFromSettings()
  );

  React.useEffect(() => {
    const api = localStorage.getItem("api_url");
    if (!api) {
      return;
    }
    axios
      .get(api + "admindatas")
      .then((res) => {
        if (res.data && res.data.result) {
          localStorage.setItem("settings", JSON.stringify(res.data.result));
          const url =
            typeof res.data.result.tutorial_video_url === "string"
              ? res.data.result.tutorial_video_url.trim()
              : "";
          setVideoUrl(url);
        }
      })
      .catch(() => { });
  }, []);

  if (!videoUrl) {
    return (
      <div style={{ padding: "24px", maxWidth: "520px" }}>
        <p style={{ color: "#374151", margin: 0 }}>
          No tutorial video is configured. Upload an MP4 in Admin → General
          Settings, then refresh this page.
        </p>
      </div>
    );
  }

  return (
    <div style={{ padding: "18px", height: "100vh" }}>
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          border: "1px solid #e5e7eb",
          boxShadow: "0 10px 28px rgba(15, 23, 42, 0.08)",
          padding: "14px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            flex: 1,
            minHeight: 0,
            width: "100%",
            backgroundColor: "#000",
            borderRadius: "14px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <video
            key={videoUrl}
            src={videoUrl}
            controls
            controlsList="nodownload"
            playsInline
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              backgroundColor: "#000",
              objectFit: "contain",
              display: "block",
            }}
          />
        </div>
      </div>
    </div>
  );
};

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      activeItem: "",
      user_id: "",
      user_details: "",
      api_url: localStorage.getItem("api_url"),
      selected_premium: "",
      notification_count: "",
      lang: ls.get("LangKeySet") || options[0],
      langKey: ls.get("LangValue"),
      items: [],
      currency: "",
      payment: "",
      license_key: "",
      premium_price: "",
      abort: "",
      showTutorialVideo: false,
      tutorialVideoUrl: "",
    };
    this.handleTutorialVideoEnded = this.handleTutorialVideoEnded.bind(this);
    this.tutorialVideoRef = React.createRef();
  }
  handleTutorialVideoEnded() {
    localStorage.removeItem("show_signup_tutorial_video");
    this.setState({
      showTutorialVideo: false,
    });
  }
  renderTutorialOverlay() {
    // Match Tutorial menu page: white card + black inner frame with rounded corners (video clips inside).
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(2, 6, 23, 0.72)",
          zIndex: 99999,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "16px",
        }}
      >
        <div
          style={{
            width: "78vw",
            maxWidth: "900px",
            height: "88vh",
            maxHeight: "940px",
            background: "#fff",
            borderRadius: "16px",
            border: "1px solid #e5e7eb",
            boxShadow: "0 10px 28px rgba(15, 23, 42, 0.08)",
            padding: "14px",
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              flex: 1,
              minHeight: 0,
              width: "100%",
              backgroundColor: "#000",
              borderRadius: "14px",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <video
              ref={this.tutorialVideoRef}
              key={this.state.tutorialVideoUrl}
              src={this.state.tutorialVideoUrl}
              autoPlay
              playsInline
              controls={false}
              disablePictureInPicture
              onEnded={this.handleTutorialVideoEnded}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: "block",
                outline: "none",
                border: "none",
                backgroundColor: "#000",
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  applyTutorialOverlayFromSettings(settings) {
    if (!settings || typeof settings !== "object") {
      return;
    }
    const url =
      typeof settings.tutorial_video_url === "string"
        ? settings.tutorial_video_url.trim()
        : "";
    const tutorialVideoEnabled = String(settings.tutorial_video) === "true";
    const showSignupTutorial =
      localStorage.getItem("show_signup_tutorial_video") === "true";
    const shouldShow =
      tutorialVideoEnabled &&
      Boolean(url) &&
      (showSignupTutorial || SHOW_TUTORIAL_OVERLAY_AFTER_LOGIN_FOR_TESTING);
    this.setState({
      tutorialVideoUrl: url,
      showTutorialVideo: shouldShow,
    });
  }

  componentDidMount() {
    const cookies = new Cookies();
    var hosturl = localStorage.getItem("web_url");
    try {
      const settings = JSON.parse(localStorage.getItem("settings") || "{}");
      this.applyTutorialOverlayFromSettings(settings);
    } catch (error) {
      this.setState({ tutorialVideoUrl: "", showTutorialVideo: false });
    }

    if (this.state.api_url) {
      axios
        .get(this.state.api_url + "admindatas")
        .then((res) => {
          if (res.data && res.data.result) {
            localStorage.setItem("settings", JSON.stringify(res.data.result));
            this.applyTutorialOverlayFromSettings(res.data.result);
          }
        })
        .catch(() => { });
    }
    if (cookies.get("onboarded") === "true") {
      let data = new FormData();
      data.append(
        "user_id",
        JSON.parse(localStorage.getItem("session_userid"))
      );
      data.append("language", this.state.langKey);

      axios({
        method: "post",
        url: this.state.api_url + "webprofile",
        data: data,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      }).then((res) => {
        if (res.data.status !== false) {
          const user_details = res.data.result;

          this.setState({
            user_details: user_details,
          });

          if (res.data.result.userstatus === 0) {
            cookies.set("onboarded", "false", { path: "/" });
            cookies.set("signuptab", false);
            localStorage.setItem("session_token", JSON.stringify());
            localStorage.setItem("session_userid", JSON.stringify());
            //this.props.history.push("/login")
            hosturl = hosturl + "/web/login";
            window.location.assign(hosturl);
            window.location.reload();
          }

          IDENTIFY_USER(user_details.user_id, { email: user_details.email });
          CAPTURE_EVENT("session_created", {
            user_id: user_details.user_id,
            user_age: user_details.age,
            user_email: user_details.email,
            user_location: user_details.location,
            user_name: user_details.user_name,
          });
        } else {
          cookies.set("onboarded", "false", { path: "/" });
          cookies.set("signuptab", false);
          this.props.history.push("/web/login");
          window.location.reload();
        }
      });
    } else {
      cookies.set("onboarded", "false", { path: "/" });
      cookies.set("signuptab", false);
      localStorage.setItem("session_token", JSON.stringify());
      localStorage.setItem("session_userid", JSON.stringify());
      hosturl = hosturl + "login";
      window.location.assign(hosturl);
      window.location.reload();
    }
  }

  render() {
    return (
      <Router basename={"/moulookweb/web"}>
        <div class="home">
          <div className="leftSideMenu d-none d-lg-block">
            <SideBar />
          </div>
          <div className="rightSideContent">
            <SimpleBar style={{ height: "100vh" }}>
              <Switch>
                <Route exact path="/app" component={PeopleNear} />
                <Route exact path="/app/settings" component={Settings} />

                {/* wallet */}

                <Route exact path="/app/wallet" component={Wallet} />
                <Route
                  exact
                  path="/app/wallethistory"
                  component={WalletHistory}
                />
                {/* promotinaloffer */}
                <Route
                  exact
                  path="/app/promotinaloffer"
                  component={Promotinaloffer}
                />
                <Route
                  exact
                  path="/app/specialpackagecoupon"
                  component={SpecialPackageCoupon}
                />

                <Route
                  exact
                  path="/app/PaymentOptions"
                  component={PaymentOptions}
                />
                <Route exact path="/app/QRcode" component={QRcode} />
                <Route exact path="/app/tutorial" component={TutorialVideoPage} />

                <Route exact path="/app/Profile" component={Profile} />
                <Route
                  exact
                  path="/app/Profile/EditProfile"
                  component={EditProfile}
                />
                <Route
                  exact
                  path="/app/Profile/ProfilePhotoEdit"
                  component={ProfilePhotoEdit}
                />
                <Route
                  exact
                  path="/app/PeopleNear/:purchase_type?"
                  component={PeopleNear}
                />
                <Route exact path="/app/Filter" component={Filter} />
                <Route exact path="/app/Feeds" component={Feeds} />

                {/*<Route exact path="/app/Boost" component={Boost} />  */}

                <Route exact path="/app/Payment" component={Payment} />
                <Route exact path="/app/scratchcard" component={ScratchCard} />
                <Route
                  exact
                  path="/app/Boostpayment"
                  component={Boostpayment}
                />
                <Route
                  exact
                  path="/app/Superlikepayment"
                  component={Superlikepayment}
                />
                <Route exact path="/app/Visitors" component={Visitors} />
                <Route exact path="/app/Friends" component={Friends} />
                <Route
                  exact
                  path="/app/FriendRequests"
                  component={FriendRequests}
                />
                <Route exact path="/app/Banner" component={Banner} />
                <Route exact path="/app/BannerAdd" component={BannerAdd} />
                <Route
                  exact
                  path="/app/BannerExpired"
                  component={BannerExpired}
                />
                <Route
                  exact
                  path="/app/Banner/BannerView/:bannerId"
                  component={BannnerView}
                />
                <Route
                  exact
                  path="/app/FindNewPeople"
                  component={FindNewPeople}
                />
                <Route exact path="/app/Explore" component={Explore} />
                <Route exact path="/app/Message" component={Message} />
                <Route
                  exact
                  path="/app/Message/MessageNew/:userId/:chatId"
                  component={MessageNew}
                />
                <Route
                  exact
                  path="/app/Visitors/VisitorNew/:userId"
                  component={VisitorNew}
                />
                <Route
                  exact
                  path="/app/Friends/FriendsNew/:userId"
                  component={FriendsNew}
                />
                <Route
                  exact
                  path="/app/FriendRequest/FriendRequestNew/:userId"
                  component={FriendRequestNew}
                />
                <Route exact path="/app/Help" component={Help} />
                <Route exact path="/app/Help/:Id" component={Help} />
                <Route exact path="/login" component={Signin} />
                <Route
                  exact
                  path="/app/Profile/Editphonefirebase"
                  component={Editphonefirebase}
                />
                {/* <Route exact path="/app/HelpMain" component={Help} /> */}
                <Route
                  exact
                  path="/app/PeopleNear/PeopleExplore/:userId"
                  component={PeopleExplore}
                />
                <Route
                  exact
                  path="/app/LikeRequests"
                  component={LikeRequests}
                />
                <Route
                  exact
                  path="/app/LikeRequest/LikeRequestNew/:userId"
                  component={LikeRequestNew}
                />
                <Route
                  exact
                  path="/app/WalletPayment"
                  component={WalletPayment}
                />
                <Route
                  exact
                  path="/app/paymentsucc/:purchase_type/:payment_session_id"
                  component={PaymentSuccPage}
                />
                <Route
                  exact
                  path="/app/cibpaymentsucc/:purchase_type"
                  component={CibSuccPage}
                />
                <Route exact path="/app/cibpay" component={Cibpay} />

                <Route component={NotFound} />
              </Switch>
            </SimpleBar>
            {this.state.showTutorialVideo &&
              this.state.tutorialVideoUrl &&
              this.renderTutorialOverlay()}
          </div>
        </div>
      </Router>
    );
  }
}

export default Home;
